module.exports = __webpack_public_path__ + "img/奥丽嘉朵logo图.a5927a1b.png";